var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    { attrs: { buttons: _vm.more.buttons } },
    [
      _c("template", { slot: "title" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.$l10n.__("Conditions Générales")) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "prelative mt-3" },
              [_c("preloader", { attrs: { display: _vm.loading } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading
          ? _c(
              "div",
              { staticClass: "flex-column" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { "overflow-y": "auto", width: "100%" },
                    attrs: { data: _vm.terms }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t.__("common.labels.type"),
                        width: "100",
                        sortable: "",
                        "sort-method": _vm.sortAlphabetically,
                        filters: _vm.termsDataFilters,
                        "filter-method": _vm.filterIsTermsType
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.termsData[scope.row.type].short
                                    ) +
                                    "\n                    "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        588727314
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t.__("common.labels.contact"),
                        sortable: "",
                        "sort-method": _vm.sortAlphabetically
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.type == "saas_cgu"
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(scope.row.acceptor.name) +
                                          "\n                        "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2317473019
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t.__(
                          "overview.tabs.TabSamTermsList.current_version"
                        ),
                        filters: [
                          { text: "Oui", value: true },
                          { text: "Non", value: false }
                        ],
                        "filter-method": _vm.filterIsLastVersion,
                        width: "180",
                        align: _vm.center
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        scope.row.isLastTermsVersion
                                          ? _vm.$l10n.__("oui")
                                          : _vm.$l10n.__("non")
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        439875966
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "acceptor",
                        label: _vm.$t.__(
                          "overview.tabs.TabSamTermsList.accepted"
                        ),
                        width: "500",
                        formatter: _vm.formatterAcceptance
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Url", width: "150" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: scope.row.link,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v(_vm._s(scope.row.version))]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3215400950
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }